import { render, staticRenderFns } from "./FileUploaderCancelIcon.vue?vue&type=template&id=35df9700"
import script from "./FileUploaderCancelIcon.vue?vue&type=script&lang=js"
export * from "./FileUploaderCancelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports